module.exports = __webpack_public_path__ + "img/veggiefolks_thumb.d6406369.jpg";